import { render, staticRenderFns } from "./nurseAlertBanner.vue?vue&type=template&id=50080c70&"
import script from "./nurseAlertBanner.vue?vue&type=script&lang=js&"
export * from "./nurseAlertBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports